// 3rd party
import { Component, ViewChild, ElementRef } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { MatDialogRef } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';

// models
import { ContactCustomer } from 'app/shared/models/contact-customer.model';

@Component({
  selector: 'app-password-dialog',
  templateUrl: './password-dialog.component.html',
  styleUrls: ['./password-dialog.component.css']
})
export class PasswordDialogComponent {

  @ViewChild('actualPassword') actualPassword: ElementRef;
  @ViewChild('newPassword') newPassword: ElementRef;
  @ViewChild('newPasswordAgain') newPasswordAgain: ElementRef;

  public actualPasswordHint: string;
  public buttonCancel: string = 'Configurations.Cancel';
  public buttonOk: string = 'Configurations.Save';
  public loading: boolean = false;
  public newPasswordAgainHint: string;
  public newPasswordHint: string;
  public title: string = 'Translate.ChangePassword';

  constructor(
    public dialogRef: MatDialogRef<PasswordDialogComponent>,
    public element: ElementRef,
    public http: Http,
    public translate: TranslateService
  ) { }

  changePassword() {
    this.validateActualPassword();
    this.validateNewPassword();
    this.validateNewPasswordAgain();
    if (this.actualPasswordHint || this.newPasswordHint || this.newPasswordAgainHint) {
      return;
    }
    this.loading = true;
    const identifier = (JSON.parse(localStorage.getItem('currentContact')) as ContactCustomer).Identifier;

    let actualPassword = this.actualPassword.nativeElement.value;
    let newPassword = this.newPassword.nativeElement.value;

    let body = JSON.stringify({ actualPassword: actualPassword, newPassword: newPassword, identifier: identifier });
    let options = new RequestOptions();
    options.headers = new Headers({ 'Content-Type': 'application/json' });
    this.http
      .put('customers/contacts/password', body, options)
      .subscribe((data) => {
        this.loading = false;
        this.dialogRef.close();
      }, err => {
        this.loading = false;
        this.translate.get('Translate.WrongPassword').subscribe((val) => this.actualPasswordHint = val);
      });
  }

  validateActualPassword() {
    if (!this.actualPassword.nativeElement.value) {
      this.translate.get('Translate.FieldCannotBeNull').subscribe((val) => this.actualPasswordHint = val);
    } else {
      this.actualPasswordHint = null;
    }
  }

  validateNewPassword() {
    if (!this.newPassword.nativeElement.value) {
      this.translate.get('Translate.FieldCannotBeNull').subscribe((val) => this.newPasswordHint = val);
    } else if (this.actualPassword.nativeElement.value === this.newPassword.nativeElement.value) {

      this.translate.get('Configurations.ValueMustBeDifferentFromCurrentPassowrd').subscribe((val) => this.newPasswordHint = val);
    } else {
      this.newPasswordHint = null;
    }
  }

  validateNewPasswordAgain() {
    if (!this.newPasswordAgain.nativeElement.value) {
      this.translate.get('Translate.FieldCannotBeNull').subscribe((val) => this.newPasswordAgainHint = val);
    } else if (this.newPasswordAgain.nativeElement.value !== this.newPassword.nativeElement.value) {
      this.translate.get('Configurations.PasswordDoesNotMatch').subscribe((val) => this.newPasswordAgainHint = val);
    } else {
      this.newPasswordAgainHint = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/password-dialog/password-dialog.component.ts